import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { slideInAndOutAnimation } from '~lmo/animations';
import { Frac, FracGraphSocketUpdate } from '~lmo/models/frac.model';
import { Report } from '~lmo/models/report.model';
import { LmoFracsService } from '~lmo/services/lmo-fracs.service';
import { LmoReportsService } from '~lmo/services/lmo-reports.service';

@Component({
  animations: [slideInAndOutAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-home',
  styleUrls: ['./lmo-frac-home.component.scss'],
  templateUrl: './lmo-frac-home.component.html',
})
export class LmoFracHomeComponent implements OnInit, OnDestroy {
  public currentFrac$: Observable<Frac>;
  public currentFracReport$: Observable<Report>;
  public currentFracGraph$: Observable<FracGraphSocketUpdate>;

  private destroy$ = new Subject<void>();

  constructor(private fracService: LmoFracsService, private reportsService: LmoReportsService) {}

  public ngOnInit() {
    this.currentFrac$ = this.fracService.currentFrac$.pipe(takeUntil(this.destroy$));

    this.currentFracReport$ = this.currentFrac$.pipe(
      filter((frac) => !!frac),
      switchMap((frac) => this.reportsService.getReportBySiteId$(frac.site.id)),
      takeUntil(this.destroy$),
    );

    this.currentFracGraph$ = this.fracService.currentFracGraph$.pipe(takeUntil(this.destroy$));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.fracService.unsubscribe();
  }
}
